import {mapFieldContract} from '../../core/fieldContract';

const cleanText = (value) =>
	typeof value === 'string' && value.trim() ? value.trim() : null;

/**
 * Convert the versioned Site field contract to Add Site form state.
 * @param {object} values canonical agent values
 * @return {object} safe Add Site patch
 */
export function mapSitePrefill(values = {}) {
	const contract = values?.__field_contract;
	if (contract?.resource !== 'site') return {};
	const mode = contract.mode;
	const patch = mapFieldContract(values, mode === 'tip');
	if (patch === null) return {};

	const parentGroupId = cleanText(patch.parentGroupId);
	const parentGroupName = cleanText(patch.parentGroupName);
	const parentId = cleanText(values.parent_site_parent_id);
	if (parentGroupId && parentGroupName) {
		patch.parentGroup = {
			site_id: parentGroupId,
			site_name: parentGroupName,
			...(parentId ? {parent_id: parentId} : {}),
		};
		patch.groupValue = patch.parentGroup;
		patch.parentGroupName = [parentGroupName];
	} else {
		delete patch.parentGroupName;
	}
	delete patch.parentGroupId;
	return patch;
}

/**
 * Convert the Site identity contract to the dashboard name editor.
 * @param {object} values canonical agent values
 * @return {object} safe Site identity patch
 */
export function mapSiteEditPrefill(values = {}) {
	const contract = values?.__field_contract;
	if (contract?.resource !== 'site') return {};
	const patch = mapFieldContract(values, contract.mode === 'tip');
	if (patch === null) return {};
	return typeof patch.site_name === 'string' && patch.site_name.trim()
		? {site_name: patch.site_name.trim()}
		: {};
}

/**
 * Convert the Site identity contract to the Configure Site form.
 *
 * Renaming a Site opens the Configure form, whose name control is
 * `groupName` - while the catalogue's rename field binds to `site_name`, the
 * name the dashboard header edits. Both are the same name.
 *
 * @param {object} values canonical agent values
 * @return {object} safe Configure form patch
 */
export function mapSiteConfigurePrefill(values = {}) {
	const contract = values?.__field_contract;
	if (contract?.resource !== 'site') return {};
	const patch = mapFieldContract(values, contract.mode === 'tip');
	if (patch === null) return {};
	const name = [patch.groupName, patch.site_name]
		.map((value) => (typeof value === 'string' ? value.trim() : ''))
		.find(Boolean);
	return name ? {groupName: name} : {};
}
